import { ITranslation } from './ITranslation';
import { SettingsmanagerService } from '../services/settingsmanager.service';
import { TranslateService } from '@ngx-translate/core';

export class TranslateModalErrorMapper {
  static mapCreateErrorToMessage(message: string, translateService: TranslateService): string {
    const duplicateEntryRegex = /Duplicate entry '(.+)-(\d+)-([a-z]{2})-([a-zA-Z0-9_]+)' for key 'translations\.uq_translation_unique_entry'/;
    const match = message.match(duplicateEntryRegex);
    if (match) {
      const [, entity, entityId, locale, label] = match;
      const msg = translateService.instant('Translations.duplicateEntry', { locale: locale, label: label });
      return msg;
    }

    return translateService.instant('Translations.createFailed');
  }

  static mapTranslationWarning(translations: ITranslation[], settingsManager: SettingsmanagerService): string {
    if (translations.length === 0) {
      return 'Translations.missing';
    }

    const entityType = translations[0].entityType;

    const requiredLabels = settingsManager.getLocalizedLabelOptionByEntity(entityType);

    const requiredLabelValues = requiredLabels.map((l) => l.value);

    const requiredLocales = settingsManager.getLocaleOptions();
    const requiredLocalesNames = requiredLocales.map((l) => l.value);

    // 3. Crea l'elenco completo delle combinazioni attese (label + locale)
    const expectedCombinations: string[] = [];
    for (const label of requiredLabelValues) {
      for (const locale of requiredLocalesNames) {
        expectedCombinations.push(`${label}__${locale}`);
      }
    }

    // 4. Crea le combinazioni effettivamente presenti
    const existingCombinations = new Set(translations.map((t) => `${t.field}__${t.locale}`));

    const missingCombinations = expectedCombinations.filter((comb) => !existingCombinations.has(comb));

    if (missingCombinations.length === expectedCombinations.length) {
      return 'Translations.missing';
    } else if (missingCombinations.length > 0) {
      // const details = missingCombinations
      //   .map(comb => {
      //     const [label, locale] = comb.split('__');
      //     return `${label} (${locale})`;
      //   })
      //   .join(', ');

      // return `Translations.incomplete: ${details}`;
      return 'Translations.incomplete';
    }
    return '';
  }
}
